import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useUserState } from '../contexts/UserContext';
import { LoginPageLayout } from '../layout/LoginPageLayout';

export const DappLogin = () => {
  const { isLoading, isConnecting, login, logout } = useUserState();

  const onLogin = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    login();
  };

  if (isConnecting || isLoading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <CircularProgress />
        <Typography variant="caption" sx={{ mt: 1, mb: 1 }}>
          Connecting
        </Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={() => {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            logout();
          }}
          sx={{ mt: 1 }}
        >
          Cancel
        </Button>
      </Box>
    );
  }
  return (
    <LoginPageLayout>
      <Button fullWidth sx={{ mt: 3 }} onClick={() => onLogin()}>
        Login
      </Button>
    </LoginPageLayout>
  );
};
